import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OneCurrencyEuroPipe } from 'src/app/pipes/one-currency-euro.pipe';
import { OneCurrencyPipe } from 'src/app/pipes/one-currency.pipe';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-big-euro',
    templateUrl: './big-euro.component.html',
    styleUrls: ['./big-euro.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class BigEuroComponent {
    @Input() value: number | undefined;
    @Input() suffix: string | undefined;
    @Input() showDecimal: boolean = false;
    @Input() smallSize: boolean = false;
    @Input() radioBtnCurrency: boolean = false;

    constructor(
        private oneCurrencyPipe: OneCurrencyPipe,
        private oneCurrencyEuroPipe: OneCurrencyEuroPipe
    ) { }

    public get symbol(): string | undefined {
        const fullFormattedAmount = this.getFormattedAmount();
        return fullFormattedAmount ? fullFormattedAmount.substring(0, 2) : undefined;
    }

    public get amount(): string | undefined {
        const fullFormattedAmount = this.getFormattedAmount();
        let result: string | undefined;

        if (fullFormattedAmount) {
            const end = this.showDecimal ? fullFormattedAmount.length - 3 : fullFormattedAmount.length;
            result = fullFormattedAmount.substring(2, end);
        } else {
            result = undefined;
        }
        
        return result;
    }

    public get decimal(): string | undefined {
        if (this.showDecimal) {
            const fullFormattedAmount = this.getFormattedAmount();
            return fullFormattedAmount ? fullFormattedAmount.substring(fullFormattedAmount.length - 3, fullFormattedAmount.length) : undefined;
        }
        return undefined;
    }

    private getFormattedAmount(): string | undefined {
        let result = this.showDecimal ? this.oneCurrencyPipe.transform(this.value) : this.oneCurrencyEuroPipe.transform(this.value);
        if (typeof result === 'string') {
            return result
        }
        return undefined;
    }
}
